"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function () {
    var device = virtual.device;
    var subDevice = virtual.subDevice;
    return {
        action: 'reportSubDevInfo',
        msgId: virtual.msgId,
        params: {
            binVer: '0.0.0.0',
            description: 'Virtual device created by @hekr/virtual',
            devTid: device.devTid,
            manufacturerName: 'HEKR-VD',
            online: true,
            subConnectType: subDevice.subWorkMode,
            subDevModel: subDevice.model,
            subDevName: subDevice.name + " virtual device",
            subDevTid: subDevice.devTid,
            subMid: subDevice.mid
        }
    };
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/reportSubDevInfo.ts